import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'vector__editor' */ './VectorEditorPage'),
);
